<template>
  <div>
    <vs-input :label="label" :placeholder="label" v-model="tag" @keydown.enter.prevent="addTag" @blur="addTag" class="w-full mb-1"/>
    <small class="form-text text-muted" v-if="value.length > 0">
      <span class="badge">
        <vs-chip class="pt-0 pb-0 pr-2 pl-2" color="primary" v-for="(val, key) in value" :key="key">
          <span v-text="val"></span>
          &nbsp;
          <feather-icon icon="XIcon" svgClasses="h-4 w-4" class="ml-1 delete-icon" @click.prevent="removeTag(key)" />
        </vs-chip>
      </span>
    </small>
  </div>
</template>

<script>
export default {
  name: 'Tagify',
  props: {
    label: {
      type: String
    },
    modelError: {
      // type: Object,
      required: false
    },
    value: {
      type: Array
    }
  },
  data () {
    return {
      tag: '',
      tags: []
    }
  },
  mounted () {

  },
  watch: {
    value (val) {
      this.tags = val
    }
  },
  methods: {
    addTag () {
      if (this.tag.length > 0) {
        this.emitValue()
      }
    },
    removeTag (key) {
      this.$delete(this.tags, key)
      this.$emit('input', this.tags)
    },
    emitValue () {
      this.tags.push(this.tag)
      this.tag = ''
      this.$emit('input', this.tags)
    }
  }
}
</script>

<style lang="scss" scoped>
  .delete-icon {
    cursor: pointer;
  }
</style>
